<template>
  <div> 
        <div v-if="formType == 10">
          <ms1StudentParticular
           :isView="isView"
           :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></ms1StudentParticular>
           <ms1PersonalBackground
            :isView="isView"
            :adminEdit="adminEdit"
            :personalBackground="personalBackground"
          ></ms1PersonalBackground>
           <studentPerformance
            :isView="isView"
            :adminEdit="adminEdit"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ms1ParentParticular
            :isView="isView"
            :adminEdit="adminEdit"
            :parentParticulars="parentParticularData"
          ></ms1ParentParticular>
          <ms1Declaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></ms1Declaration>
          <ms1StudentFiles
           :isView="isView"
           :adminEdit="adminEdit"
            :studentFiles="studentFiles"
          ></ms1StudentFiles>
        </div>
        <div v-if="formType == 8">
          <ds2StudentParticular
          :isView="isView"
          :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></ds2StudentParticular>
           <ds2PersonalBackground
           :isView="isView"
           :adminEdit="adminEdit"
            :personalBackground="personalBackground"
          ></ds2PersonalBackground>
           <studentPerformance
           :isView="isView"
           :adminEdit="adminEdit"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ds2ParentParticular
            :isView="isView"
            :adminEdit="adminEdit"
            :parentParticulars="parentParticularData"
          ></ds2ParentParticular>
          <ds2Declaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></ds2Declaration>
          <ds2StudentFiles
            :isView="isView"
            :adminEdit="adminEdit"
            :studentFiles="studentFiles"
          ></ds2StudentFiles>
        </div>
        <div v-if="formType == 7">
          <ds1StudentParticular
            :isView="isView"
            :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></ds1StudentParticular>
           <ds1PersonalBackground
           :isView="isView"
           :adminEdit="adminEdit"
            :personalBackground="personalBackground"
          ></ds1PersonalBackground>
           <studentPerformance
           :adminEdit="adminEdit"
           :isView="isView"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ds1ParentParticular
           :adminEdit="adminEdit"
           :isView="isView"
            :parentParticulars="parentParticularData"
          ></ds1ParentParticular>
          <ds1Declaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></ds1Declaration>
          <ds1StudentFiles
            :adminEdit="adminEdit"
            :isView="isView"
            :studentFiles="studentFiles"
          ></ds1StudentFiles>
        </div>
        <div v-if="formType == 6">
          <fsInterimStudentParticular
           :isView="isView"
           :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></fsInterimStudentParticular>
           <fsInterimPersonalBackground
           :isView="isView"
           :adminEdit="adminEdit"
            :personalBackground="personalBackground"
          ></fsInterimPersonalBackground>
           <studentPerformance
            :isView="isView"
            :adminEdit="adminEdit"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <fsInterimParentParticular
            :isView="isView"
            :adminEdit="adminEdit"
            :parentParticulars="parentParticularData"
          ></fsInterimParentParticular>
          <fsInterimDeclaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></fsInterimDeclaration>
          <fsInterimStudentFiles
           :isView="isView"
           :adminEdit="adminEdit"
            :studentFiles="studentFiles"
          ></fsInterimStudentFiles>
        </div>
        <div v-if="formType == 1">
          <fs2StudentParticular
           :isView="isView"
           :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></fs2StudentParticular>
           <fs2PersonalBackground
           :isView="isView"
           :adminEdit="adminEdit"
            :personalBackground="personalBackground"
          ></fs2PersonalBackground>
           <studentPerformance
           :isView="isView"
           :adminEdit="adminEdit"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <fs2ParentParticular
           :isView="isView"
           :adminEdit="adminEdit"
            :parentParticulars="parentParticularData"
          ></fs2ParentParticular>
          <fs2Declaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></fs2Declaration>
          <fs2StudentFiles
            :adminEdit="adminEdit"
            :isView="isView"
            :studentFiles="studentFiles"
          ></fs2StudentFiles>
        </div>
        <div v-if="formType == 0">
          <fsStudentParticular
            :isView="isView"
            :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></fsStudentParticular>
          <fsPersonalBackground
           :isView="isView"
           :adminEdit="adminEdit"
            :personalBackground="personalBackground"
          ></fsPersonalBackground>
          <fsParentParticular
            :isView="isView"
            :adminEdit="adminEdit"
            :parentParticulars="parentParticularData"
          ></fsParentParticular>
          <fsDeclaration
            :declaration="declaration"
           :adminEdit="adminEdit"
           :isView="isView"
          ></fsDeclaration>
          <fsStudentFiles
           :isView="isView"
           :adminEdit="adminEdit"
            :studentFiles="studentFiles"
          ></fsStudentFiles>
        </div>
        <div v-if="formType == 9">
          <ds3StudentParticular
           :isView="isView"
           :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></ds3StudentParticular>
          <ds3PersonalBackground
          :isView="isView"
          :adminEdit="adminEdit"
            :personalBackground="personalBackground"
          ></ds3PersonalBackground>
          <studentPerformance
            :adminEdit="adminEdit"
            :isView="isView"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
           <ds3ParentParticular
            :adminEdit="adminEdit"
            :isView="isView"
            :parentParticulars="parentParticularData"
          ></ds3ParentParticular>
          <ds3Declaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></ds3Declaration>
          <ds3StudentFiles
            :adminEdit="adminEdit"
            :isView="isView"
            :studentFiles="studentFiles"
          ></ds3StudentFiles>
        </div>
        <div v-if="formType == 2">
          <ds4StudentParticular
           :isView="isView"
           :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></ds4StudentParticular>
          <ds4PersonalBackground
           :adminEdit="adminEdit"
           :isView="isView"
            :personalBackground="personalBackground"
          ></ds4PersonalBackground>
           <studentPerformance
            :adminEdit="adminEdit"
            :isView="isView"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
            <ds4ParentParticular
            :adminEdit="adminEdit"
            :isView="isView"
            :parentParticulars="parentParticularData"
          ></ds4ParentParticular>
          <ds4Declaration
            :declaration="declaration"
            :isView="isView"
            :adminEdit="adminEdit"
          ></ds4Declaration>
          <ds4StudentFiles
           :adminEdit="adminEdit"
           :isView="isView"
            :studentFiles="studentFiles"
          ></ds4StudentFiles>
        </div>
        <div v-if="formType == 3">
          <ds5StudentParticular
          :adminEdit="adminEdit"
          :isView="isView"
            :studentParticular="studentParticular"
          ></ds5StudentParticular>
          <ds5PersonalBackground
          :adminEdit="adminEdit"
          :isView="isView"
            :personalBackground="personalBackground"
          ></ds5PersonalBackground>
          <studentPerformance
            :adminEdit="adminEdit"
            :isView="isView"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ds5ParentParticular
           :adminEdit="adminEdit"
           :isView="isView"
            :parentParticulars="parentParticularData"
          ></ds5ParentParticular>
          <ds5Declaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></ds5Declaration>
          <ds5StudentFiles
            :isView="isView"
            :adminEdit="adminEdit"
            :studentFiles="studentFiles"
          ></ds5StudentFiles>
        </div>
        <div v-if="formType == 11">
          <ms3HkdseStudentParticular
            :adminEdit="adminEdit"
            :isView="isView"
            :studentParticular="studentParticular"
          ></ms3HkdseStudentParticular>
          <ms3HkdsePersonalBackground
            :adminEdit="adminEdit"
            :isView="isView"
            :personalBackground="personalBackground"
          ></ms3HkdsePersonalBackground>
          <studentPerformance
            :adminEdit="adminEdit"
            :isView="isView"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <ms3HkdseParentParticular
            :adminEdit="adminEdit"
            :isView="isView"
            :parentParticulars="parentParticularData"
          ></ms3HkdseParentParticular>
          <ms3HkdseDeclaration
            :declaration="declaration"
           :adminEdit="adminEdit"
           :isView="isView"
          ></ms3HkdseDeclaration>
          <ms3HkdseStudentFiles
           :adminEdit="adminEdit"
           :isView="isView"
            :studentFiles="studentFiles"
          ></ms3HkdseStudentFiles>
          <ms3HkdseQuestionnaire
           :isView="isView"
           :adminEdit="adminEdit"
            :questionnaire="questionnaire"
          ></ms3HkdseQuestionnaire>
          <ms3HkdseApplicantLanguage
            :isView="isView"
            :adminEdit="adminEdit"
            :applicantLanguage="applicantLanguage"
          ></ms3HkdseApplicantLanguage>
          <ms3HkdseSubjectsApplied
            :isView="isView"
            :adminEdit="adminEdit"
            :subjectsApplied="subjectsApplied"
          ></ms3HkdseSubjectsApplied>
        </div>
        <div v-if="formType == 4">
          <msStudentParticular
           :isView="isView"
           :adminEdit="adminEdit"
            :studentParticular="studentParticular"
          ></msStudentParticular>
          <msPersonalBackground
          :isView="isView"
          :adminEdit="adminEdit"
            :personalBackground="personalBackground"
          ></msPersonalBackground>
          <studentPerformance
            :isView="isView"
            :adminEdit="adminEdit"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <msParentParticular
           :isView="isView"
           :adminEdit="adminEdit"
            :parentParticulars="parentParticularData"
          ></msParentParticular>
          <msDeclaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></msDeclaration>
          <msStudentFiles
            :isView="isView"
            :adminEdit="adminEdit"
            :studentFiles="studentFiles"
          ></msStudentFiles>
          <msQuestionnaire
            :adminEdit="adminEdit"
            :isView="isView"
            :questionnaire="questionnaire"
          ></msQuestionnaire>
          <msApplicantLanguage
           :adminEdit="adminEdit"
           :isView="isView"
            :applicantLanguage="applicantLanguage"
          ></msApplicantLanguage>
          <msSubjectsApplied
             :adminEdit="adminEdit"
             :isView="isView"
            :subjectsApplied="subjectsApplied"
          ></msSubjectsApplied>
        </div>
        <div v-if="formType == 5">
          <msIBDPStudentParticular
            :adminEdit="adminEdit"
            :isView="isView"
            :studentParticular="studentParticular"
          ></msIBDPStudentParticular>
          <msIBDPPersonalBackground
           :adminEdit="adminEdit"
           :isView="isView"
            :personalBackground="personalBackground"
          ></msIBDPPersonalBackground>
          <studentPerformance
            :adminEdit="adminEdit"
            :isView="isView"
            :studentPerformance="studentPerformance"
          ></studentPerformance>
          <msIBDPParentParticular
           :adminEdit="adminEdit"
           :isView="isView"
            :parentParticulars="parentParticularData"
          ></msIBDPParentParticular>
          <msIBDPDeclaration
            :declaration="declaration"
           :isView="isView"
           :adminEdit="adminEdit"
          ></msIBDPDeclaration>
          <msIBDPStudentFiles
           :isView="isView"
           :adminEdit="adminEdit"
            :studentFiles="studentFiles"
          ></msIBDPStudentFiles>
          <msIBDPQuestionnaire
           :adminEdit="adminEdit"
           :isView="isView"
            :questionnaire="questionnaire"
          ></msIBDPQuestionnaire>
          <msIBDPApplicantLanguage
            :isView="isView"
            :adminEdit="adminEdit"
            :applicantLanguage="applicantLanguage"
          ></msIBDPApplicantLanguage>
          <msIBDPSubjectsApplied
            :isView="isView"
            :adminEdit="adminEdit"
            :subjectsApplied="subjectsApplied"
          ></msIBDPSubjectsApplied>
        </div>
  </div>
</template>

<script>
import studentPerformance from "@/components/studentPerformance";

import fsStudentParticular from "@/components/fs1/studentParticular";
import fsParentParticular from "@/components/fs1/parentParticular";
import fsPersonalBackground from "@/components/fs1/personalBackground";
import fsStudentFiles from "@/components/fs1/studentFiles";
import fsDeclaration from "@/components/fs1/declaration";

import fsInterimPersonalBackground from "@/components/fsInterim/personalBackground";
import fsInterimStudentParticular from "@/components/fsInterim/studentParticular";
import fsInterimParentParticular from "@/components/fsInterim/parentParticular";
import fsInterimDeclaration from "@/components/fsInterim/declaration";
import fsInterimStudentFiles from "@/components/fsInterim/studentFiles";

import ms1PersonalBackground from "@/components/ms1/personalBackground";
import ms1StudentParticular from "@/components/ms1/studentParticular";
import ms1ParentParticular from "@/components/ms1/parentParticular";
import ms1Declaration from "@/components/ms1/declaration";
import ms1StudentFiles from "@/components/ms1/studentFiles";

import ds1PersonalBackground from "@/components/ds1/personalBackground";
import ds1StudentParticular from "@/components/ds1/studentParticular";
import ds1ParentParticular from "@/components/ds1/parentParticular";
import ds1Declaration from "@/components/ds1/declaration";
import ds1StudentFiles from "@/components/ds1/studentFiles";

import ds2PersonalBackground from "@/components/ds2/personalBackground";
import ds2StudentParticular from "@/components/ds2/studentParticular";
import ds2ParentParticular from "@/components/ds2/parentParticular";
import ds2Declaration from "@/components/ds2/declaration";
import ds2StudentFiles from "@/components/ds2/studentFiles";

import fs2PersonalBackground from "@/components/fs2/personalBackground";
import fs2StudentParticular from "@/components/fs2/studentParticular";
import fs2ParentParticular from "@/components/fs2/parentParticular";
import fs2Declaration from "@/components/fs2/declaration";
import fs2StudentFiles from "@/components/fs2/studentFiles";

import ds3StudentParticular from "@/components/ds3/studentParticular";
import ds3ParentParticular from "@/components/ds3/parentParticular";
import ds3PersonalBackground from "@/components/ds3/personalBackground";
import ds3StudentFiles from "@/components/ds3/studentFiles";
import ds3Declaration from "@/components/ds3/declaration";

import ds4StudentParticular from "@/components/ds4/studentParticular";
import ds4ParentParticular from "@/components/ds4/parentParticular";
import ds4PersonalBackground from "@/components/ds4/personalBackground";
import ds4StudentFiles from "@/components/ds4/studentFiles";
import ds4Declaration from "@/components/ds4/declaration";

import ds5StudentParticular from "@/components/ds5/studentParticular";
import ds5ParentParticular from "@/components/ds5/parentParticular";
import ds5PersonalBackground from "@/components/ds5/personalBackground";
import ds5StudentFiles from "@/components/ds5/studentFiles";
import ds5Declaration from "@/components/ds5/declaration";

import msStudentParticular from "@/components/ms/studentParticular";
import msParentParticular from "@/components/ms/parentParticular";
import msPersonalBackground from "@/components/ms/personalBackground";
import msStudentFiles from "@/components/ms/studentFiles";
import msDeclaration from "@/components/ms/declaration";
import msQuestionnaire from "@/components/ms/questionnaire";
import msApplicantLanguage from "@/components/ms/applicantLanguage";
import msSubjectsApplied from "@/components/ms/subjectsApplied";

import ms3HkdseStudentParticular from "@/components/ms3Hkdse/studentParticular";
import ms3HkdseParentParticular from "@/components/ms3Hkdse/parentParticular";
import ms3HkdsePersonalBackground from "@/components/ms3Hkdse/personalBackground";
import ms3HkdseStudentFiles from "@/components/ms3Hkdse/studentFiles";
import ms3HkdseDeclaration from "@/components/ms3Hkdse/declaration";
import ms3HkdseQuestionnaire from "@/components/ms3Hkdse/questionnaire";
import ms3HkdseApplicantLanguage from "@/components/ms3Hkdse/applicantLanguage";
import ms3HkdseSubjectsApplied from "@/components/ms3Hkdse/subjectsApplied";

import msIBDPStudentParticular from "@/components/msIBDP/studentParticular";
import msIBDPParentParticular from "@/components/msIBDP/parentParticular";
import msIBDPPersonalBackground from "@/components/msIBDP/personalBackground";
import msIBDPStudentFiles from "@/components/msIBDP/studentFiles";
import msIBDPDeclaration from "@/components/msIBDP/declaration";
import msIBDPQuestionnaire from "@/components/msIBDP/questionnaire";
import msIBDPApplicantLanguage from "@/components/msIBDP/applicantLanguage";
import msIBDPSubjectsApplied from "@/components/msIBDP/subjectsApplied";

export default {
  components: {
    studentPerformance,

    ms1StudentParticular,
    ms1PersonalBackground,
    ms1ParentParticular,
    ms1Declaration,
    ms1StudentFiles,

    ds1StudentParticular,
    ds1PersonalBackground,
    ds1ParentParticular,
    ds1Declaration,
    ds1StudentFiles,

    ds2StudentParticular,
    ds2PersonalBackground,
    ds2ParentParticular,
    ds2Declaration,
    ds2StudentFiles,

    fsInterimStudentParticular,
    fsInterimPersonalBackground,
    fsInterimParentParticular,
    fsInterimDeclaration,
    fsInterimStudentFiles,

    fs2StudentParticular,
    fs2PersonalBackground,
    fs2ParentParticular,
    fs2Declaration,
    fs2StudentFiles,
    
    fsDeclaration,
    fsStudentFiles,
    fsPersonalBackground,
    fsParentParticular,
    fsStudentParticular,

    ds3Declaration,
    ds3StudentFiles,
    ds3PersonalBackground,
    ds3ParentParticular,
    ds3StudentParticular,

    ds5Declaration,
    ds5StudentFiles,
    ds5PersonalBackground,
    ds5ParentParticular,
    ds5StudentParticular,

    msDeclaration,
    msStudentFiles,
    msPersonalBackground,
    msParentParticular,
    msStudentParticular,
    msQuestionnaire,
    msApplicantLanguage,
    msSubjectsApplied,

    ms3HkdseDeclaration,
    ms3HkdseStudentFiles,
    ms3HkdsePersonalBackground,
    ms3HkdseParentParticular,
    ms3HkdseStudentParticular,
    ms3HkdseQuestionnaire,
    ms3HkdseApplicantLanguage,
    ms3HkdseSubjectsApplied,

    msIBDPDeclaration,
    msIBDPStudentFiles,
    msIBDPPersonalBackground,
    msIBDPParentParticular,
    msIBDPStudentParticular,
    msIBDPQuestionnaire,
    msIBDPApplicantLanguage,
    msIBDPSubjectsApplied,

    ds4Declaration,
    ds4StudentFiles,
    ds4PersonalBackground,
    ds4ParentParticular,
    ds4StudentParticular,
  },
  props: {
    applicationDetail:{
      type: Object,
      default: () => {},
    },
    studentPerformance:{
      type: Object,
      default: () => {},
    },
    studentParticular: {
      type: Object,
      default: function () {},
    },
    personalBackground:{
      type: Object,
      default: () => {},
    },
    parentParticularData:{
      type: Object,
      default: () => {},
    },
    declaration:{
      type: Object,
      default: () => {},
    },
    studentFiles:{
      type: Array,
      default() {
        return []
      }
    },
    adminEdit:{
      type: Boolean,
      default: false,
    },
    isView:{
      type: Boolean,
      default: false,
    },
    id: {
      type: Number,
      default: 0,
    },
    type: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      show:false,
      formType: 0,
    };
  },
  watch:{
    applicationDetail:{
      handler(val){
        if(val!=null){
           this.int(val);
        }
      },
      deep: true,
      immediate: true,
    }
  },
  methods: {
    int() {
      this.$nextTick(()=>{
        this.formType = this.type;
        this.$forceUpdate()
      })  
    },
    isEditGetApplicationDetail(val) {
        this.studentParticular = JSON.parse(
          this.componentMethods(val.components, 0)||'{}'
        );
        this.parentParticularData.parentParticulars = JSON.parse(
          this.componentMethods(val.components, 1)||'{}'
        );
        this.personalBackground = JSON.parse(
          this.componentMethods(val.components, 2)||'{}'
        );
        this.studentFiles = JSON.parse(
          this.componentMethods(val.components, 3)||'{}'
        );
        this.questionnaire.questionnaires = JSON.parse(
          this.componentMethods(val.components, 4)||'{}'
        );
        this.applicantLanguage.applicantLanguages = JSON.parse(
          this.componentMethods(val.components, 5)||'{}'
        );
        this.subjectsApplied = JSON.parse(
          this.componentMethods(val.components, 6)||'{}'
        );
        this.declaration = JSON.parse(
          this.componentMethods(val.components, 7)||'{}'
        );
        this.studentPerformance.studentPerformances = JSON.parse(
          this.componentMethods(val.components, 8)||'{}'
        );
        this.$forceUpdate();
    },
    componentMethods(components, type) {
      return components.filter((v) => {
        return v.type == type;
      })[0].value;
    },
  },
};
</script>

<style lang="scss" scoped>
.application-detail {
  background-color: #fff;
  padding-top: 60px;
}
.application-content {
  padding: 0 60px;
}
.el-breadcrumb {
  margin: 30px 0;
}
.dialog-title {
  font-size: 20px;
}
.dialog-text {
  font-size: 16px;
}
::v-deep {
  .el-breadcrumb__item:first-child .el-breadcrumb__inner {
    color: #0064ed;
  }
  .el-button--primary {
    width: auto;
    background-color: #0962fa;
    border-color: #0962fa;
    font-size: 20px;
    font-weight: bold;
  }
}
@media (min-width: $phoneMinWidth) and (max-width: $phoneMaxWidth) {
  .application-content{
    padding: 0 0.625rem;
  }
}
</style>